module.exports = "https://static.wagwalking.com/_next/static/images/pick-caregiver-5c606a95e6f822bb4a44a81258effcb4.svg";